import { useCallback, useEffect, useState } from 'react';
import { useNavigationContainerRef, useSegments } from 'expo-router';
import Head from 'expo-router/head';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Sets the browser tab title based on the focused screen's `customDocumentTitle`
 * and `title` options. Recomputes whenever the active route segments change.
 */
export const DocumentTitle = () => {
  const segments = useSegments();
  const navigationRef = useNavigationContainerRef();

  // ─── State ───────────────────────────────────────────────────────────

  const [title, setTitle] = useState(DEFAULT_TITLE);

  // ─── Handlers ────────────────────────────────────────────────────────

  const setDocumentTitle = useCallback(() => {
    const ref = navigationRef.current;

    if (!ref) return;

    requestIdleCallback(() => {
      const options = ref.getCurrentOptions() as | Record<string, unknown> | undefined; // prettier-ignore
      const customTitle = options?.customDocumentTitle;

      setTitle(typeof customTitle === 'string' ? customTitle : DEFAULT_TITLE);
    });
  }, [navigationRef, segments]);

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(setDocumentTitle, [setDocumentTitle]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Head>
      <title>{title}</title>
    </Head>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const DEFAULT_TITLE = 'sweetgreen';
